import type { Suggestion } from '@zillow/search-box';
import { buildURL } from '@zillow/search-box';
import { setdim, track } from '@zillow/universal-analytics';

import type { SearchLocation } from '../../../types/searchBox';
import { formatListingButtonGAEvent } from '../../../utils/analytics';
import type { ListingButtonConfig } from './ListingButtons';

export function trackAndRedirect(
    { preCallback, searchType, trackingLabel }: ListingButtonConfig,
    searchTerm: Suggestion,
    location?: SearchLocation
) {
    // optional function to fire before tracking and URL redirection
    preCallback?.();
    // custom dimension based on spec here:
    // https://zillowgroup.atlassian.net/wiki/spaces/zproddev/pages/171805429/Listing+Type+Interstitial
    setdim({ dimension138: 'listingTypeInterstitial' });
    track(formatListingButtonGAEvent(trackingLabel));
    const redirectUrl = buildURL(searchTerm, location, searchType);
    if (typeof redirectUrl === 'string') {
        window.location.assign(redirectUrl);
    }
}
